<template>
  <div class="product-explanation">
    <div class="panel">
      <div class="panel-header">
        <h2 class="panel-title"><i class="fas fa-shopping-bag"></i> 商品自动讲解</h2>
      </div>

      <div class="explanation-settings">
        <div class="settings-section">
          <div class="settings-grid">
            <div class="setting-card">
              <div class="card-flex">
                <h4>单品讲解</h4>
                <div class="toggle-switch">
                  <label class="switch">
                    <input type="checkbox" value="item" @change="selectExplain"
                           :checked="$store.state.explain_type=='item'">
                    <span class="slider round"></span>
                  </label>
                  <span>启用</span>
                </div>
              </div>
              <div class="setting-group">
                <label>随机频率设置：</label>
                <input type="number" v-model="explain?.config.item.start" min="1" @change="updateExplain">
                <span>至</span>
                <input type="number" v-model="explain?.config.item.end" min="1" @change="updateExplain">
                <span>秒</span>
              </div>
              <div class="setting-group">
                <label>选择商品序号：</label>
                <input type="number" v-model="explain?.config.item.scope" min="1" @change="updateExplain">
                <span>号</span>
              </div>
            </div>

            <div class="setting-card">
              <div class="card-flex">
                <h4>循环讲解</h4>
                <div class="toggle-switch">
                  <label class="switch">
                    <input type="checkbox" value="loop" @change="selectExplain"
                           :checked="$store.state.explain_type=='loop'">
                    <span class="slider round"></span>
                  </label>
                  <span>启用</span>
                </div>
              </div>
              <div class="setting-group">
                <label>随机频率设置：</label>
                <input type="number" v-model="explain?.config.loop.start" min="1" @change="updateExplain">
                <span>至</span>
                <input type="number" v-model="explain?.config.loop.end" min="1" @change="updateExplain">
                <span>秒</span>
              </div>
              <div class="setting-group">
                <label>选择序号范围：</label>
                <input type="number" v-model="explain?.config.loop.scope_min" min="1" @change="updateExplain">
                <span>至</span>
                <input type="number" v-model="explain?.config.loop.scope_max" min="1" @change="updateExplain">
                <span>号</span>
              </div>
            </div>

            <div class="setting-card">
              <div class="card-flex">
                <h4>指定讲解</h4>
                <div class="toggle-switch">
                  <label class="switch">
                    <input type="checkbox" value="specify" @change="selectExplain"
                           :checked="$store.state.explain_type=='specify'">

                    <span class="slider round"></span>
                  </label>
                  <span>启用</span>
                </div>
              </div>
              <div class="setting-group">
                <label>随机频率设置：</label>
                <input type="number" v-model="explain?.config.specify.start" min="1" @change="updateExplain">
                <span>至</span>
                <input type="number" v-model="explain?.config.specify.end" min="1" @change="updateExplain">
                <span>秒</span>
              </div>
              <div class="setting-group" style="justify-content: flex-end; gap: 10px;">
                <label style="margin-right: auto;">序号：</label>
                <input type="text" v-model="explain?.config.specify.scope" class="form-input"
                       placeholder="请输入序号，逗号分隔"
                       style="width: 200px;" @change="updateExplain">
                <button class="btn btn-primary" @click="openProductSelect">选择</button>
              </div>
            </div>
          </div>


        </div>

        <!-- 商品列表 -->
        <div class="product-list-section">
          <div class="product-list-header">
            <div class="product-sort">
              <label style="color: rgba(170, 170, 170, 0.9);">商品排序：</label>
              <select class="form-select" v-model="priceSortType"
                      style="margin: 0 15px; padding: 6px 12px; border: 1px solid rgba(80, 80, 80, 0.5); border-radius: 8px; background: rgba(50, 50, 50, 0.8); color: rgba(170, 170, 170, 0.9);">
                <option v-for="item in goodsSort" :value="item.value">{{ item.name }}</option>
              </select>
            </div>
            <div style="display: flex">
              <div class="product-search">
                <input type="text" v-model="searchKeyword" placeholder="搜索商品..." class="form-input"
                       style="padding: 6px 12px; border: 1px solid rgba(80, 80, 80, 0.5); border-radius: 8px; margin-right: 10px; background: rgba(50, 50, 50, 0.8); color: rgba(170, 170, 170, 0.9);"
                       @keyup.enter="searchProduct">
                <button class="btn btn-primary" style="margin-right: 10px;" @click="searchProduct">搜索</button>
                <button class="btn btn-secondary" style="margin-right: 10px;" @click="openSellPointModal">商品卖点设置
                </button>
              </div>
              <button
                  class="btn"
                  :class="$store.state.explainKeyword  ? 'btn-danger' : 'btn-primary'"
                  style="padding: 8px 20px; border-radius: 8px;"
                  @click="startAutoExplanation"
              >
                {{ $store.state.explainKeyword ? '停止优先讲解' : '开始优先讲解' }}
              </button>
            </div>
          </div>
          <div class="product-table">
            <table>
              <thead>
              <tr>
                <th>序号</th>
                <th>商品名称</th>
                <template v-if="user?.select_type=='douyin'">
                  <th>点击率</th>
                  <th>成交率</th>
                  <th>销售额</th>
                </template>
                <template v-else-if="user?.select_type=='taobao'">
                  <th>曝光人数</th>
                  <th>点击次数</th>
                  <th>加购人数</th>
                  <th>成交人数</th>
                </template>


                <th>价格</th>
                <th style="text-align: center;">操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(product, index) in products" :key="index" :id="`product-row-${index}`">
                <td>{{ index + 1 }}</td>
                <td>
                  <div class="product-info">
                    <img :src="product.cover" alt="product.title" class="product-image">
                    <div class="product-title-wrapper" v-if="user?.select_type=='douyin'">
                      <span class="goods-title" :title="product.title">{{ product.title }}</span>
                      <div class="product-elastic-title" @click="editElasticTitle(product)"
                           v-if="!product.editingElastic">
                        <span style="color: #fff">商品热点：</span>{{ product.elastic_title || '点击编辑热点' }}
                      </div>
                      <input v-else
                             v-model="product.elastic_title"
                             @blur="saveElasticTitle(product)"
                             @keyup.enter="saveElasticTitle(product)"
                             class="elastic-title-input"
                             placeholder="输入热点"
                             ref="elasticInput"
                             v-focus>
                    </div>
                  </div>
                </td>
                <template v-if="user?.select_type=='douyin'">
                  <td>{{ product.djl }}%</td>
                  <td>{{ product.cjl }}%</td>
                  <td>￥{{ product.pay_amt }}</td>
                  <td>￥{{ product.buy_price }}</td>

                </template>

                <template v-if="user?.select_type=='taobao'">
                  <td>{{ product.show_num }}</td>
                  <td>{{ product.click_num }}</td>
                  <td>{{ product.pay_num }}</td>
                  <td>{{ product.cart_num }}</td>
                  <td>￥{{ product.buy_price }}</td>
                </template>
                <template v-if="user?.select_type=='tiktok'">
                  <td>{{ product.buy_price }}</td>
                </template>
                <td style="text-align: center">
                  <a href="#" class="action-link action-keyword"
                     @click.prevent="openKeywordReplyModal(product)">关键词</a>
                  <a href="#" class="action-link action-sort"
                     @click.prevent="openSortModal(product,index+1)">商品排序</a>
                  <a href="#" class="action-link action-explain" :class="{ 'explaining': product.explain }"
                     @click.prevent="toggleExplaining(product)">{{ product.explain ? '正在讲解' : '商品讲解' }}</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="pagination-container">
            <div class="pagination">
              <span class="page-info">共{{ products.length }}件商品</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品卖点设置弹窗 -->
    <div v-if="showSellPointModal" class="modal-overlay" @click="closeSellPointModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>商品卖点设置</h3>
          <button class="modal-close" @click="closeSellPointModal">&times;</button>
        </div>
        <div class="modal-body sell-point-row">
          <div class="sell-point-section">
            <label>商品序号范围</label>
            <div class="range-control">
              <input type="number" v-model.number="sellPointMin" class="range-input" min="0">
              <span class="range-separator">至</span>
              <input type="number" v-model.number="sellPointMax" class="range-input" min="0">
              <span class="range-unit">号</span>
            </div>
          </div>
          <div class="sell-point-section">
            <label>商品卖点文字</label>
            <textarea v-model="sellPointText" placeholder="请输入商品卖点文字" class="sell-point-textarea"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeSellPointModal">取消</button>
          <button class="btn btn-primary" @click="saveSellPoint">保存</button>
        </div>
      </div>
    </div>

    <!-- 关键词回复设置弹窗 -->
    <div v-if="showKeywordReplyModal" class="modal-overlay" @click="closeKeywordReplyModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>编辑关键词</h3>
          <button class="modal-close" @click="closeKeywordReplyModal">&times;</button>
        </div>
        <div class="modal-body">

          <div class="keyword-reply-section">
            <label>关键词</label>
            <textarea v-model="currentProduct.keywords" placeholder="请输入关键词 多个请用空格隔开"
                      class="reply-textarea"></textarea>
          </div>

        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeKeywordReplyModal">取消</button>
          <button class="btn btn-primary" @click="saveKeywordReply">保存</button>
        </div>
      </div>
    </div>

    <!-- 排序设置弹窗 -->
    <div v-if="showSortModal" class="modal-overlay" @click="closeSortModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>设置排序</h3>
          <button class="modal-close" @click="closeSortModal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="sort-section">
            <label>排序数值</label>
            <input type="number" v-model="sortValue" min="1" class="sort-input">
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeSortModal">取消</button>
          <button class="btn btn-primary" @click="saveSort">确定</button>
        </div>
      </div>
    </div>

    <!-- 序号选择弹窗 -->
    <div v-if="showNumberSelectModal" class="modal-overlay" @click="closeNumberSelectModal">
      <div class="modal-content number-select-modal" @click.stop>
        <div class="modal-header">
          <h3>选择商品序号</h3>
          <button class="modal-close" @click="closeNumberSelectModal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="number-grid">
            <button
                v-for="num in products.length"
                :key="num"
                :class="['number-item', { 'selected': selectedNumbers.includes(String(num)) }]"
                @click="toggleNumber(String(num))"
            >
              {{ num }}
            </button>
          </div>
          <div class="selection-info">
            <span>已选择 {{ selectedNumbers.length }} 个序号</span>
            <div class="selection-actions">
              <button class="btn btn-sm btn-secondary" @click="selectAll">全选</button>
              <button class="btn btn-sm btn-secondary" @click="clearSelection">清空</button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="showNumberSelectModal = false">取消</button>
          <button class="btn btn-primary" @click="handleConfirmClick">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import {delay, getRandomInt} from "@/utils/function";

export default {
  name: 'ProductExplanation',
  data() {
    return {
      showSellPointModal: false,
      sellPointMin: '',
      sellPointMax: '',
      sellPointText: '',
      showKeywordReplyModal: false,


      goodsSort: [
        {
          name: "按商品的价格 从低到高排序",
          value: "price-asc",
        }, {

          name: "按曝光点击率 从高到低排序",
          value: "ctr-desc",
        },
        {
          name: "按商品销售额 从高到低排序",
          value: "revenue-desc",
        },
        {
          name: "按曝光成交率 从高到低排序",
          value: "cvr-desc",
        }
      ],


      priceSortType: "",

      currentProduct: null,
      keywordReply: {
        keywords: '',
      },
      showSortModal: false,
      sortValue: 1,
      replyImages: [],
      products: [],
      explain: null,
      settings: {
        singlePopup: {
          enabled: false,
          minInterval: 10,
          maxInterval: 30,
          productIndex: 1
        },
        loopPopup: {
          enabled: false,
          minInterval: 10,
          maxInterval: 30,
          minProduct: 1,
          maxProduct: 5
        },
        zoomPopup: {
          enabled: false,
          minInterval: 10,
          maxInterval: 30
        }
      },
      isAutoExplanationRunning: false,
      showNumberSelectModal: false,
      selectedNumbers: [],
      selectedNumbersText: '',
      searchKeyword: ''
    }
  },
  computed: {

    user() {
      return this.$store.state.userInfo
    }

  },
  watch: {

    priceSortType() {

      this.applyPriceSort();
    }

  },
  async mounted() {


    this.getLiveGoods()
    await this.getExplain()
    if (this.explain.type) {
      this.startTimer();
    }
  },
  methods: {
    async selectExplain(e) {

      if (e.target.checked) {
        this.$store.commit('setExplainType', e.target.value);
        this.$store.commit("setExplainIndex", 0)
      } else {
        this.$store.commit('setExplainType', "");
      }
      var name = '单品讲解';
      switch (e.target.value) {
        case "item":
          name = "单品讲解";
          break;
        case "loop":
          name = "循环讲解";
        case "specify":
          name = "指定讲解";
          break;
      }
      if (e.target.checked) {

        this.$dialog.tips({
          message: `开启【${name}】成功`,
          type: "success"
        })
        this.$parent.explainIndex = 1;
        this.startTimer();

      } else {
        this.$dialog.tips({
          message: `关闭【${name}】成功`,
          type: "success"
        })
      }

    },


    async startTimer() {
      if (this.$store.state.explain_type !== '') {
        const config = this.explain.config[this.$store.state.explain_type];
        const timer = getRandomInt(config.start, config.end) * 1000;
        if (this.$store.state.explainKeywordShow == false) {

          switch (this.$store.state.explain_type) {
            case "loop":
              var res = await http.post("api/auto/autoExplain", {
                type: this.$store.state.explain_type,
                index: this.$store.state.explainIndex
              })
              if (res.code == 200) {
                this.$store.commit('setPlainIndex', this.$store.state.explainIndex + 1);
              }
              break;
            case "specify":
              var res = await http.post("api/auto/autoExplain", {
                type: this.$store.state.explain_type,
                index: this.$store.state.explainIndex
              })
              if (res.code == 200) {
                this.$store.commit('setPlainIndex', this.$store.state.explainIndex + 1);
              }
              break;
            case "item":
              http.post("api/auto/autoExplain", {
                type: this.$store.state.explain_type,
                index: this.$store.state.explainIndex
              })


              break;
          }

        }

        await delay(timer);
        this.startTimer();
      }

    },


    async updateExplain(showTips = true) {
      const res = await http.post("api/live/updateExplain", this.explain)
      if (res.code == 200) {
        this.showNumberSelectModal = false;
        if (showTips) {
          this.$dialog.tips({
            message: res.msg,
            type: "success",
          })
        }

        return res;
      }
      if (showTips) {
        this.$dialog.tips({
          message: res.msg,
          type: "error",
        })
      }

      return res;
    },
    async getExplain() {

      const res = await http.get("api/live/getExplain")
      this.explain = res.data;


    },
    async startAutoExplanation() {
      this.$store.commit("setExplainKeyword", !this.$store.state.explainKeyword)
      if (this.$store.state.explainKeyword) {

        if(!this.$store.state.liveWs){
          this.$dialog.tips({
            message:"请先到直播账号管理，连接直播间",
            type:"error"
          });
          this.$store.commit("setExplainKeyword", false)

          return;
        }
        this.$dialog.tips({
          message: '自动讲解已开始',
          type: "success"
        })
        this.startLiveKeyword();
        // 这里可以添加自动讲解的逻辑
      } else {
        this.$dialog.tips({
          message: '自动讲解已停止',
          type: "success"
        })
      }

    },

    async startLiveKeyword(){

      if (this.$store.state.liveData.messageData.nickname != this.$store.state.userInfo?.platform.nickname) {
        if(this.$store.state.goodsKeyword!=this.$store.state.liveData.messageData.content){
          this.$store.commit("setGoodsKeyword",this.$store.state.liveData.messageData.content);
          const res=await http.post("api/auto/keywordExplain",this.$store.state.liveData.messageData);
          if(res.code==200){
            this.$store.commit("setExplainKeywordShow",true);
            setTimeout(()=>{
              this.$store.commit("setExplainKeywordShow",false);
            },7000)
          }
        }
      }
      await delay(1000)
      this.startLiveKeyword();

    },


    openProductSelect() {
      console.log(this.explain.config.specify.scope.split(","))
      if (this.explain.config.specify.scope) {
        this.selectedNumbers = this.explain.config.specify.scope.split(",")
      }

      this.showNumberSelectModal = true;
    },

    closeNumberSelectModal() {
      this.showNumberSelectModal = false;
    },

    async getLiveGoods() {
      this.$dialog.loading({text: "加载中..."})
      const res = await http.get("api/live/liveList")
      this.$dialog.closeLoading();
      if (res.code == 200) {
        this.products = res.data;

        return;
      }
      this.$dialog.tips({
        message: res.msg,
        type: 'error'
      })
    },
    async applyPriceSort() {


      this.$dialog.loading({text: "商品排序中..."})

      const res = await http.post("api/live/goodsSort", {type: this.priceSortType})
      this.$dialog.closeLoading();

      if (res.code == 200) {
        this.$dialog.tips({
          message: res.msg,
          type: "success",
        })
        this.getLiveGoods();
      }
    },

    toggleNumber(num) {
      const index = this.selectedNumbers.indexOf(num);
      if (index > -1) {
        this.selectedNumbers.splice(index, 1);
      } else {
        this.selectedNumbers.push(num);
      }
    },

    editElasticTitle(product) {
      this.$set(product, 'editingElastic', true)
      this.$nextTick(() => {
        const inputs = this.$refs.elasticInput
        if (inputs && inputs.length > 0) {
          inputs[inputs.length - 1].focus()
        } else if (inputs) {
          inputs.focus()
        }
      })
    },

    async saveElasticTitle(product) {
      const res = await http.post("api/live/setPoint", {
        promotion_id: product.promotion_id,
        text: product.elastic_title,
      });
      if (res.code == 200) {
        this.$set(product, 'editingElastic', false)
        this.$dialog.tips({message: res.msg, type: "success"})
      } else {
        this.$dialog.tips({message: res.msg, type: "error"})

      }

      // 这里可以添加保存到后端的逻辑
    },

    searchProduct() {
      if (!this.searchKeyword.trim()) {
        this.$dialog.tips({message: '请输入搜索关键词', type: 'warning'})
        return
      }

      const keyword = this.searchKeyword.toLowerCase()
      const matchIndex = this.products.findIndex(product =>
          product.title.toLowerCase().includes(keyword)
      )

      if (matchIndex !== -1) {
        const element = document.getElementById(`product-row-${matchIndex}`)
        if (element) {
          element.scrollIntoView({behavior: 'smooth', block: 'center'})
          element.classList.add('search-highlight')
          setTimeout(() => {
            element.classList.remove('search-highlight')
          }, 3000)
        }
      } else {
        this.$dialog.tips({message: '未找到匹配的商品', type: 'error'})
      }
    },

    selectAll() {
      this.selectedNumbers = Array.from({length: this.products.length}, (_, i) => String(i + 1));
    },

    clearSelection() {
      this.selectedNumbers = [];
    },

    confirmNumberSelection() {
      if (this.selectedNumbers.length > 0) {
        this.selectedNumbersText = this.selectedNumbers.sort((a, b) => a - b).join(', ');
        this.$message.success(`已选择 ${this.selectedNumbers.length} 个序号`);
      } else {
        this.selectedNumbersText = '';
      }
      // 确保弹窗关闭
      this.$nextTick(() => {
        this.showNumberSelectModal = false;
      });
    },

    handleConfirm() {
      if (this.selectedNumbers.length > 0) {
        this.selectedNumbersText = this.selectedNumbers.sort((a, b) => a - b).join(', ');
        this.$message.success(`已选择 ${this.selectedNumbers.length} 个序号`);
      } else {
        this.selectedNumbersText = '';
      }
      this.showNumberSelectModal = false;
    },

    handleConfirmClick() {
      // 处理选择数据
      this.explain.config.specify.scope = this.selectedNumbers.sort((a, b) => a - b).join(',');

      this.updateExplain();
      // 直接关闭弹窗

    },

    openSellPointModal() {
      this.showSellPointModal = true;
    },

    closeSellPointModal() {
      this.showSellPointModal = false;
    },

    triggerImageUpload() {
      this.$refs.imageInput.click();
    },

    handleImageUpload(event) {
      const files = event.target.files;
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.sellPointImages.push(e.target.result);
          };
          reader.readAsDataURL(files[i]);
        }
      }
    },

    removeImage(index) {
      this.sellPointImages.splice(index, 1);
    },

    async saveSellPoint() {
      // 保存商品卖点逻辑

      this.products.forEach((v, k) => {
        if (this.sellPointMin == '' && this.sellPointMax == '') {
          http.post("api/live/setPoint", {
            promotion_id: v.promotion_id,
            text: this.sellPointText,
          });
          v.elastic_title = this.sellPointText;
        } else {
          if (k + 1 >= this.sellPointMin && k + 1 <= this.sellPointMax) {
            http.post("api/live/setPoint", {
              promotion_id: v.promotion_id,
              text: this.sellPointText,
            });
            v.elastic_title = this.sellPointText;

          }
        }
      })



      this.$dialog.tips({message: "设置成功", type: "success"})
      this.showSellPointModal = false;
    },

    openKeywordReplyModal(product) {
      this.currentProduct = product;

      this.replyImages = [];
      this.showKeywordReplyModal = true;
    },

    closeKeywordReplyModal() {
      this.showKeywordReplyModal = false;
      this.currentProduct = null;
    },

    triggerReplyImageUpload() {
      this.$refs.replyImageInput.click();
    },

    handleReplyImageUpload(event) {
      const files = event.target.files;
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.replyImages.push(e.target.result);
          };
          reader.readAsDataURL(files[i]);
        }
      }
    },

    removeReplyImage(index) {
      this.replyImages.splice(index, 1);
    },

    insertVariable(variable) {
      this.keywordReply.reply += variable;
    },

    async saveKeywordReply() {
      // 保存关键词回复逻辑

      const data = {

        product_id: this.currentProduct.product_id,
        promotion_id: this.currentProduct.promotion_id,
        keywords: this.currentProduct.keywords,

      }

      const res = await http.post("api/live/setKeyword", data)
      if (res.code == 200) {
        this.$dialog.tips({message: res.msg, type: "success"})
        this.showKeywordReplyModal = false;

        return;
      }
      this.$dialog.tips({message: res.msg, type: "error"})

    },

    openSortModal(product, index) {
      this.currentProduct = product;
      this.sortValue = index;
      this.showSortModal = true;
    },

    closeSortModal() {
      this.showSortModal = false;
      this.currentProduct = null;
    },

    async saveSort() {
      // 保存排序逻辑

      console.log(this.currentProduct, this.sortValue)
      this.$dialog.loading("排序中...")
      const res = await http.post("api/live/setSort", {
        promotion_id: this.currentProduct.promotion_id,
        sort: this.sortValue
      })
      this.$dialog.closeLoading()

      if (res.code == 200) {
        this.$dialog.tips({
          message: res.msg,
          type: "success"
        })
        this.showSortModal = false;
        this.getLiveGoods();

        return;
      }
      this.$dialog.tips({
        message: res.msg,
        type: "error"
      })

    },

    async toggleExplaining(product) {

      this.products.forEach(v => {
        if (v != product) {
          v.explain = false;
        }
      })

      const res = await http.post("api/live/explain", {
        promotion_id: product.promotion_id,
        product_id: product.product_id
      })

      if (res.code == 200) {
        this.$dialog.tips({message: res.msg, type: "success"})
        product.explain = res.data
      } else {
        this.$dialog.tips({message: res.msg, type: "error"})
        product.explain = res.data

      }

    }
  }
}
</script>

<style lang="less" scoped>
.product-explanation {
  background: transparent;
}

.explanation-settings {
  margin-top: 20px;
}

.settings-section {
  margin-bottom: 10px;
}

.settings-section h3 {
  margin-bottom: 15px;
  color: #ddd;
  font-size: 18px;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  border-radius: 12px;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.setting-card {
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.95) 0%, rgba(35, 35, 35, 0.95) 100%);
  border-radius: 12px;
  padding:10px 20px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 4px 12px rgba(170, 170, 170, 0.1);
  transition: all 0.3s ease;
}

.setting-card .card-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.setting-card:hover {
  border-color: rgba(170, 170, 170, 0.4);
  box-shadow: 0 6px 20px rgba(170, 170, 170, 0.15);
}

.setting-card h4 {
  margin-bottom: 15px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 15px;
}

.toggle-switch {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
}

.toggle-switch span {
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  font-weight: 500;
}

.switch {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 28px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(34, 211, 238, 0.2) 100%);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
  box-shadow: 0 3px 8px rgba(139, 92, 246, 0.4);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

input:checked + .slider {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(34, 211, 238, 0.5) 100%);
}

input:checked + .slider:before {
  transform: translateX(26px);
  background: linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%);
  box-shadow: 0 3px 8px rgba(255, 255, 255, 0.4);
}

.slider.round {
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}

.setting-group {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.setting-group label {
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
}

.setting-group span:not(.slider) {
  color: rgba(170, 170, 170, 0.7);
  font-size: 14px;
}

.setting-group input {
  width: 60px;
  padding: 8px 12px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 8px;
  background: rgba(40, 40, 40, 0.8);
  color: #ccc;
  font-size: 14px;
  transition: all 0.3s ease;
}

.setting-group input:focus {
  outline: none;
  border-color: #888;
  box-shadow: 0 0 0 3px rgba(100, 100, 100, 0.2);
}

.image-upload-section {
  margin-bottom: 20px;
}

.upload-area {
  border: 2px dashed #555;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-area:hover {
  border-color: #888;
  background-color: rgba(100, 100, 100, 0.2);
}

.upload-area i {
  font-size: 48px;
  color: #888;
  margin-bottom: 10px;
}

.upload-area p {
  color: #888;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
}

.image-item {
  background: rgba(50, 50, 50, 0.8);
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 1px solid rgba(70, 70, 70, 0.5);
}

.product-image {
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 10px;
}

.image-actions {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.empty-state {
  grid-column: 1 / -1;
  text-align: center;
  padding: 40px;
  color: #999;
}

.product-card {
  background: rgba(248, 249, 250, 0.9);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(60, 60, 60, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.product-card h4 {
  margin-bottom: 15px;
  color: #ccc;
}

.form-group {
  margin-bottom: 15px;
}

.form-input {
  padding: 8px 12px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 8px;
  background: rgba(50, 50, 50, 0.8);
  font-size: 14px;
  color: #ccc;
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: #888;
  box-shadow: 0 0 0 3px rgba(100, 100, 100, 0.2);
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #ccc;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group textarea {
  height: 100px;
  resize: vertical;
}

.product-image-preview {
  width: 100px;
  height: 100px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-image {
  text-align: center;
  color: #999;
}

.no-image i {
  font-size: 32px;
  margin-bottom: 5px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  flex-shrink: 0;
}

.btn-primary {
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 50%, #4f46e5 100%);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6) 0%, rgba(75, 85, 99, 0.6) 100%);
  color: #d1d5db;
  border: 1px solid rgba(156, 163, 175, 0.5);
}

.btn-secondary:hover {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.7) 0%, rgba(75, 85, 99, 0.7) 100%);
  border-color: rgba(156, 163, 175, 0.7);
}

.btn-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

.btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
}

.btn-sm {
  padding: 8px 12px;
  font-size: 14px;
}

@media (max-width: 768px) {
  .settings-grid {
    grid-template-columns: 1fr;
  }

  .image-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.1);
}

.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 15px 30px 0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
}


.panel:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 商品列表样式 */
.product-list-section {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  border-radius: 12px;
}

.product-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 15px 20px;
  background: linear-gradient(135deg, rgba(60, 60, 60, 0.6) 0%, rgba(50, 50, 50, 0.6) 100%);
  border-radius: 8px;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.product-sort {
  display: flex;
  align-items: center;
}

.product-search {
  display: flex;
  align-items: center;
}

.product-table {
  background: transparent;
  overflow: hidden;
  margin-bottom: 15px;
  max-height: 200px;
  overflow-y: auto;
}


.product-table table {
  width: 100%;
  border-collapse: collapse;
}

.product-table th,
.product-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
  color: rgba(170, 170, 170, 0.9);
}

.product-table th {
  background: linear-gradient(135deg, rgba(80, 80, 80, 0.6) 0%, rgba(60, 60, 60, 0.6) 100%);
  background: #262626;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
  border-bottom: 1px solid rgba(100, 100, 100, 0.5);
  position: sticky;
  top: 0;
}

.product-table tr:hover {
  background: rgba(170, 170, 170, 0.08);
}

.product-info {
  display: flex;
  align-items: center;
  gap: 10px;

  .goods-title {
    width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.product-title-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.product-elastic-title {
  font-size: 12px;
  color: rgba(170, 170, 170, 0.6);
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-height: 18px;
}

.product-elastic-title:hover {
  background: rgba(170, 170, 170, 0.1);
  color: rgba(170, 170, 170, 0.9);
}

.elastic-title-input {
  font-size: 12px;
  padding: 2px 6px;
  border: 1px solid rgba(139, 92, 246, 0.5);
  border-radius: 4px;
  background: rgba(50, 50, 50, 0.9);
  color: #e8e8e8;
  width: 200px;
  outline: none;
}

.elastic-title-input:focus {
  border-color: rgba(139, 92, 246, 0.8);
  box-shadow: 0 0 8px rgba(139, 92, 246, 0.3);
}

.search-highlight {
  background: rgba(16, 185, 129, 0.15) !important;
  animation: highlightPulse 1s ease-in-out;
}

@keyframes highlightPulse {
  0%, 100% {
    background: rgba(16, 185, 129, 0.15);
  }
  50% {
    background: rgba(16, 185, 129, 0.3);
  }
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid rgba(60, 60, 60, 0.2);
}

.product-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.action-link {
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 4px;
}

.action-keyword {
  color: #60a5fa;
}

.action-keyword:hover {
  color: #93c5fd;
  background: rgba(59, 130, 246, 0.2);
}

.action-sort {
  color: #34d399;
}

.action-sort:hover {
  color: #6ee7b7;
  background: rgba(34, 197, 94, 0.2);
}

.action-explain {
  color: #fbbf24;
}

.action-explain:hover {
  color: #fcd34d;
  background: rgba(251, 191, 36, 0.2);
}

/* 正在讲解状态 */
.action-link.explaining {
  color: #10b981;
  font-weight: bold;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0 10px 0;
  border-top: 1px solid rgba(60, 60, 60, 0.5);
}

.pagination {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-info {
  font-size: 14px;
  color: rgba(170, 170, 170, 0.8);
}

.page-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.page-numbers {
  display: flex;
  gap: 5px;
}

.page-btn {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 6px;
  background: rgba(100, 100, 100, 0.3);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.page-btn:hover {
  background: rgba(120, 120, 120, 0.4);
  color: rgba(170, 170, 170, 0.95);
  border-color: rgba(170, 170, 170, 0.5);
}

.page-btn.active {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.6) 0%, rgba(99, 102, 241, 0.6) 100%);
  color: #c4b5fd;
  border-color: rgba(167, 139, 250, 0.7);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.page-buttons .btn.active {
  background: linear-gradient(90deg, #5a5a5a 0%, #777 100%);
  border: none;
  color: #eee;
  box-shadow: 0 4px 16px rgba(100, 100, 100, 0.3);
}

.page-buttons .btn-secondary {
  background: rgba(60, 60, 60, 0.8);
  color: #aaa;
  border: 1px solid rgba(80, 80, 80, 0.5);
}

.page-buttons .btn-secondary:hover {
  background: rgba(80, 80, 80, 0.4);
  border-color: rgba(100, 100, 100, 0.6);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .settings-grid {
    grid-template-columns: 1fr;
  }

  .product-list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .product-search {
    width: 100%;
    justify-content: space-between;
  }
}

@media (max-width: 768px) {
  .panel {
    padding: 15px;
  }

  .product-table {
    overflow-x: auto;

  }

  .product-table table {
    min-width: 800px;
  }

  .pagination {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: linear-gradient(135deg, rgba(45, 45, 45, 0.98) 0%, rgba(35, 35, 35, 0.98) 100%);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(170, 170, 170, 0.1);
  border: 1px solid rgba(170, 170, 170, 0.3);
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid rgba(170, 170, 170, 0.25);
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: rgba(170, 170, 170, 0.9);
}

.modal-close {
  background: rgba(170, 170, 170, 0.2);
  border: 1px solid rgba(170, 170, 170, 0.4);
  font-size: 24px;
  color: rgba(170, 170, 170, 0.9);
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background: rgba(170, 170, 170, 0.3);
  color: #e0e0e0;
}

.modal-body {
  padding: 25px;
}

.sell-point-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.sell-point-section {
  flex: 1;
}

.sell-point-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #ccc;
}

.range-control {
  display: flex;
  align-items: center;
  gap: 10px;
}

.range-input {
  width: 100px;
  padding: 10px 12px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  background: rgba(50, 50, 50, 0.8);
  color: #ccc;
}

.range-input:focus {
  outline: none;
  border-color: #888;
  box-shadow: 0 0 0 3px rgba(100, 100, 100, 0.2);
}

.range-separator {
  color: #aaa;
  font-size: 14px;
}

.range-unit {
  font-size: 14px;
  color: #aaa;
}

.sell-point-textarea {
  width: 95%;
  height: 38px;
  padding: 10px 12px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 8px;
  background: rgba(40, 40, 40, 0.8);
  color: #ccc;
  resize: none;
  overflow: hidden;
  font-size: 14px;
  line-height: 1.4;
  transition: all 0.3s ease;
}

.sell-point-textarea:focus {
  outline: none;
  border-color: #888;
  box-shadow: 0 0 0 3px rgba(100, 100, 100, 0.2);
}

.image-upload-area {
  margin-top: 10px;
}

.upload-box {
  border: 2px dashed rgba(80, 80, 80, 0.5);
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 15px;
}

.upload-box:hover {
  border-color: #888;
  background: rgba(80, 80, 80, 0.3);
}

.upload-box i {
  font-size: 32px;
  color: #888;
  margin-bottom: 10px;
}

.upload-box p {
  margin: 0;
  color: #aaa;
  font-size: 14px;
}

.image-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
}

.image-preview-item {
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(60, 60, 60, 0.2);
}

.preview-image {
  width: 100%;
  height: 100px;
  object-fit: cover;
}

.remove-image {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(60, 60, 60, 0.9);
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  color: #888;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.remove-image:hover {
  background: #dc3545;
  color: white;
  transform: scale(1.1);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 25px;
  border-top: 1px solid rgba(60, 60, 60, 0.5);
  background: rgba(40, 40, 40, 0.9);
  border-radius: 0 0 16px 16px;
}


.keyword-reply-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
}

.keyword-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(170, 170, 170, 0.4);
  border-radius: 8px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  transition: all 0.3s ease;
}

.keyword-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 10px rgba(170, 170, 170, 0.2);
}

.reply-textarea {
  width: 100%;
  min-height: 100px;
  padding: 12px;
  border: 1px solid rgba(170, 170, 170, 0.4);
  border-radius: 8px;
  background: rgba(30, 30, 30, 0.9);
  color: rgba(170, 170, 170, 0.9);
  resize: vertical;
  font-size: 14px;
  transition: all 0.3s ease;
}

.reply-textarea:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.6);
  box-shadow: 0 0 10px rgba(170, 170, 170, 0.2);
}

.variables-list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.variable-tag {
  display: inline-block;
  padding: 6px 12px;
  background: rgba(170, 170, 170, 0.2);
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 16px;
  color: rgba(170, 170, 170, 0.9);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.variable-tag:hover {
  background: rgba(170, 170, 170, 0.3);
  border-color: rgba(170, 170, 170, 0.5);
  transform: translateY(-2px);
}

/* 排序设置弹窗样式 */
.sort-section {
  margin-bottom: 20px;
}

.sort-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #ccc;
}

.sort-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 8px;
  background: rgba(50, 50, 50, 0.8);
  color: #ccc;
  font-size: 14px;
  transition: all 0.3s ease;
}

.sort-input:focus {
  outline: none;
  border-color: #888;
  box-shadow: 0 0 0 3px rgba(100, 100, 100, 0.2);
}

/* 响应式弹窗 */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 20px;
  }

  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 15px 20px;
  }

  .image-preview-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  }

  .preview-image {
    height: 80px;
  }
}

/* 序号选择弹窗样式 */
.number-select-modal {
  max-width: 800px;
  max-height: 90vh;
}

.number-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 8px;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 10px;
}

.number-item {
  width: 100%;
  padding: 10px 5px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 6px;
  background: rgba(50, 50, 50, 0.8);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #ccc;
  transition: all 0.3s ease;
}

.number-item:hover {
  border-color: #888;
  background: rgba(80, 80, 80, 0.4);
  transform: scale(1.05);
}

.number-item.selected {
  background: linear-gradient(90deg, #5a5a5a 0%, #777 100%);
  border-color: #888;
  color: #eee;
  box-shadow: 0 4px 12px rgba(100, 100, 100, 0.3);
}

.selection-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid rgba(60, 60, 60, 0.1);
}

.selection-info span {
  font-size: 14px;
  color: #aaa;
}

.selection-actions {
  display: flex;
  gap: 10px;
}

@media (max-width: 768px) {
  .number-grid {
    grid-template-columns: repeat(5, 1fr);
    max-height: 300px;
  }

  .number-item {
    padding: 8px 3px;
    font-size: 12px;
  }
}
</style>